/**
 * Returning-player digest types (Round 14 Phase G).
 *
 * When a Ghost-state player returns after 24+ real hours, the server
 * computes a short "while you were away" digest and sends it to the
 * client. The digest appears in the journal as a curated summary of
 * world changes — not a notification dump, but a letter from the world.
 *
 * Spec: `docs/design/returning-player-experience.md` §1.2, §5.
 *
 * @packageDocumentation
 */
// ── Constants ───────────────────────────────────────────────────────────
/** Minimum Ghost duration (ms) before a return summary is generated. */
export const RETURN_SUMMARY_MIN_GHOST_MS = 24 * 60 * 60 * 1000; // 24 hours
/** Maximum entries in the return digest. */
export const RETURN_SUMMARY_MAX_ENTRIES = 8;
/** Screen fade-in duration on Ghost return (ms). */
export const RETURN_FADE_IN_MS = 3000;
/** Ambient sound fade-in delay on Ghost return (ms). */
export const RETURN_AMBIENT_FADE_MS = 5000;
// ── Message constant ────────────────────────────────────────────────────
/** Server → Client: returning-player digest after Ghost→Active transition.
 *  Sent once per login when the player was Ghost for ≥ 24 real hours. */
export const MSG_RETURN_DIGEST = 'return_digest';
//# sourceMappingURL=returnDigest.js.map